import React from "react";
import Badge from "../../../../components/atoms/Badge";
import { OrderItemStatuses } from "../../../../shared/enums";

interface Props {
  status: OrderItemStatuses;
}
const OrderItemStatusBadge: React.FC<Props> = ({ status }) => {
  switch (status) {
    case OrderItemStatuses.PENDING:
      return <Badge color="yellow">예약신청</Badge>;
    case OrderItemStatuses.CONFIRMED_ORDER:
      return <Badge color="yellow">주문확정</Badge>;
    case OrderItemStatuses.COMPLETED_PAYMENT:
      return <Badge color="gray">결제완료</Badge>;
    case OrderItemStatuses.REQUEST_GOODS_ISSUE:
      return <Badge color="green">출고의뢰</Badge>;
    case OrderItemStatuses.COMPLETED_GOODS_ISSUE:
      return <Badge color="green">출고완료</Badge>;
    case OrderItemStatuses.COMPLETED_DELIVERY:
      return <Badge color="mint">배송완료</Badge>;
    case OrderItemStatuses.CONFIRMED_PURCHASE:
      return <Badge color="purple">구매확정</Badge>;
    case OrderItemStatuses.CANCELED_ORDER:
      return <Badge color="red">예약취소</Badge>;
    default:
      return <>-</>;
  }
};
export default OrderItemStatusBadge;
